var React = require('react');

function ArrowRightGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.707 8.29306L14 0.58606L12.586 2.00006L18.586 8.00006H1C0.447 8.00006 0 8.44806 0 9.00006C0 9.55206 0.447 10.0001 1 10.0001H18.586L12.586 16.0001L14 17.4141L21.707 9.70706C22.098 9.31606 22.098 8.68406 21.707 8.29306Z"}));
}

ArrowRightGreen.defaultProps = {"width":"22","height":"18","viewBox":"0 0 22 18"};

module.exports = ArrowRightGreen;

ArrowRightGreen.default = ArrowRightGreen;
